/**
 * Feature Flags Configuration
 * Central configuration for all feature flags
 */

import type {
  FeatureFlagConfig,
  FeatureFlags,
} from "./feature-flags.interface";

export const FEATURE_FLAG_CONFIGS: Record<
  keyof FeatureFlags,
  FeatureFlagConfig
> = {
  USE_SECURE_COOKIE_AUTH: {
    key: "USE_SECURE_COOKIE_AUTH",
    defaultValue: false,
    description:
      "Use HTTP-only secure cookies for authentication instead of localStorage",
    requiresReload: true,
  },

  ENABLE_PERFORMANCE_METRICS: {
    key: "ENABLE_PERFORMANCE_METRICS",
    defaultValue: false,
    description: "Track and report client-side performance metrics",
    requiresReload: false,
  },

  ENABLE_NETWORK_SPEED_MONITORING: {
    key: "ENABLE_NETWORK_SPEED_MONITORING",
    defaultValue: false,
    description: "Monitor network speed and connection quality",
    requiresReload: false,
  },

  ENABLE_MULTI_LANGUAGE: {
    key: "ENABLE_MULTI_LANGUAGE",
    defaultValue: false,
    description: "Enable multi-language support (i18n)",
    requiresReload: true,
  },

  ENABLE_ADVANCED_SCANNING: {
    key: "ENABLE_ADVANCED_SCANNING",
    defaultValue: false,
    description:
      "Enable advanced scanning features (multiple formats, batch processing)",
    requiresReload: false,
  },

  ENABLE_DEBUG_MODE: {
    key: "ENABLE_DEBUG_MODE",
    defaultValue: import.meta.env.DEV,
    description: "Enable debug logging and development tools",
    requiresReload: false,
  },

  SHOW_FEATURE_FLAGS_UI: {
    key: "SHOW_FEATURE_FLAGS_UI",
    defaultValue: import.meta.env.DEV,
    description: "Show feature flags toggle UI in settings",
    requiresReload: false,
  },
};

// Default values for all flags
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = Object.entries(
  FEATURE_FLAG_CONFIGS,
).reduce((acc, [key, config]) => {
  acc[key as keyof FeatureFlags] = config.defaultValue;
  return acc;
}, {} as FeatureFlags);
